import {
  put,
  fork,
  call,
  take,
  takeEvery,
  all,
  select,
} from 'redux-saga/effects';
import app from '../../app';
import {
  loadCouponCompletion,
  loadGiftListCompletion,
  loadCashListCompletion,
  loadStoreListCompletion,
  loadPostageListCompletion,
  batchGetCouponCompletion,
  batchCancelDonateCouponCompletion,
  batchDonateCouponCompletion,
  loadPickerGiftListCompletion,
  loadReceivedCouponListCompletion,
  loadNewuserCouponListCompletion,
  loadCouponPkgCompletion,
  takeCouponPkgCompletion,
  loadRegCouponPkgCompletion,
  takeRegCouponPkgCompletion,
  loadCouponBatchListCompletion,
  loadCouponBatchDonateListCompletion,
} from '../../actions';

export function* watchLoadGiftList() {
  yield takeEvery('LOAD_GIFT_LIST', function*({ willReload }) {
    const { list, query } = yield select(state => state.mall.coupon.giftMaster);
    const tabDict = { unused: 0, donated: 1, used: 2 };
    let start = 0;
    let tab = 0;

    if (!willReload && list) {
      start = list.length;
    }
    tab = tabDict[query.tab];

    const options = {
      url: '/api/coupons',
      data: {
        start,
        size: query.size,
        tab,
        type: 1,
        name: query.keyword || undefined,
      },
    };

    const result = yield call(app.httpFetch, options);
    yield put(
      loadGiftListCompletion(
        result.error,
        (result.data && result.data.listData) || []
      )
    );
  });
}

export function* watchLoadCashList() {
  yield takeEvery('LOAD_CASH_LIST', function*({ willReload }) {
    const { list, query } = yield select(state => state.mall.coupon.cashMaster);
    const tabDict = { unused: 0, donated: 1, used: 2 };
    let start = 0;
    let tab = 0;

    if (!willReload && list) {
      start = list.length;
    }
    tab = tabDict[query.tab];

    const options = {
      url: '/api/coupons',
      data: {
        start,
        size: query.size,
        tab,
        type: 2,
        name: query.keyword || undefined,
      },
    };
    const result = yield call(app.httpFetch, options);
    yield put(
      loadCashListCompletion(
        result.error,
        (result.data && result.data.listData) || []
      )
    );
  });
}

export function* watchLoadStoreList() {
  yield takeEvery('LOAD_STORE_LIST', function*({ willReload }) {
    const { list, query } = yield select(
      state => state.mall.coupon.storeMaster
    );
    const tabDict = { unused: 0, used: 2 };
    let start = 0;
    let tab = 0;

    if (!willReload && list) {
      start = list.length;
    }
    tab = tabDict[query.tab];

    const options = {
      url: '/api/coupons/lijing',
      data: {
        start,
        size: query.size,
        tab,
        name: query.keyword || undefined,
      },
    };
    const result = yield call(app.httpFetch, options);
    yield put(
      loadStoreListCompletion(
        result.error,
        (result.data && result.data.listData) || []
      )
    );
  });
}

export function* watchLoadPostageList() {
  yield takeEvery('LOAD_POSTAGE_LIST', function*({ willReload }) {
    const { list, query } = yield select(
      state => state.mall.coupon.postageMaster
    );
    const tabDict = { unused: 0, donated: 1, used: 2 };
    let start = 0;
    let tab = 0;

    if (!willReload && list) {
      start = list.length;
    }
    tab = tabDict[query.tab];

    const options = {
      url: '/api/coupons',
      data: { start, size: query.size, tab, type: 3 },
    };
    const result = yield call(app.httpFetch, options);
    yield put(
      loadPostageListCompletion(
        result.error,
        (result.data && result.data.listData) || []
      )
    );
  });
}

export function* watchLoadCoupon() {
  yield takeEvery('LOAD_COUPON', function*({ code }) {
    const options = {
      url: `/api/coupons/${code}`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadCouponCompletion(code, result.error, result.data));
  });
}

export function* watchBatchGetCoupon() {
  while (true) {
    const { couponIds } = yield take('BATCH_GET_COUPON');
    const options = {
      url: `/api/coupons/receive`,
      method: 'POST',
      data: {
        ids: couponIds,
      },
    };
    const result = yield call(app.httpFetch, options);
    yield put(
      batchGetCouponCompletion(
        result.error,
        (result.data && result.data.listData) || []
      )
    );
  }
}

export function* watchBatchCancelDonateCoupon() {
  while (true) {
    const { couponIds } = yield take('BATCH_CANCEL_DONATE_COUPON');
    const options = {
      url: `/api/coupons/deliver/cancel`,
      method: 'POST',
      data: { ids: couponIds },
    };
    const result = yield call(app.httpFetch, options);
    yield put(
      batchCancelDonateCouponCompletion(
        result.error,
        (result.data && result.data.listData) || []
      )
    );
  }
}

export function* watchBatchDonateCoupon() {
  while (true) {
    const { couponIds } = yield take('BATCH_DONATE_COUPON');
    const options = {
      url: `/api/coupons/deliver`,
      method: 'POST',
      data: {
        ids: couponIds,
      },
    };
    const result = yield call(app.httpFetch, options);
    yield put(
      batchDonateCouponCompletion(
        result.error,
        (result.data && result.data.listData) || []
      )
    );
  }
}

export function* watchLoadPickerGiftList() {
  yield takeEvery('LOAD_PICKER_GIFT_LIST', function*({ willReload }) {
    const { list, query } = yield select(state => state.mall.coupon.giftPicker);
    let start = 0;

    if (!willReload && list) {
      start = list.length;
    }

    const options = {
      url: '/api/coupons/usable',
      data: { start, size: query.size },
    };

    const result = yield call(app.httpFetch, options);
    yield put(
      loadPickerGiftListCompletion(
        result.error,
        (result.data && result.data.listData) || []
      )
    );
  });
}

export function* watchLoadReceivedCouponList() {
  yield takeEvery('LOAD_RECEIVED_COUPON_LIST', function*() {
    const options = {
      url: '/api/coupons/unreadV2',
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadReceivedCouponListCompletion(result.error, result.data));
  });
}

export function* watchLoadNewuserCouponList() {
  yield takeEvery('LOAD_NEWUSER_COUPON_LIST', function*() {
    const options = {
      url: '/api/coupons/newusergift',
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadNewuserCouponListCompletion(result.error, result.data));
  });
}

export function* watchLoadCouponPkg() {
  yield takeEvery('LOAD_COUPON_PKG', function*({ pkgId }) {
    const [id, code] = pkgId.split('-');
    const options = {
      url: `/api/giftPack/${id}/${code}`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadCouponPkgCompletion(pkgId, result.error, result.data));
  });
}

export function* watchTakeCouponPkg() {
  yield takeEvery('TAKE_COUPON_PKG', function*({ pkgId }) {
    const [id, code] = pkgId.split('-');
    const options = {
      url: `/api/giftPack/${id}/${code}/get`,
      method: 'POST',
    };
    const result = yield call(app.httpFetch, options);
    yield put(takeCouponPkgCompletion(pkgId, result.error, result.data));
  });
}

export function* watchLoadRegCouponPkg() {
  yield takeEvery('LOAD_REG_COUPON_PKG', function*({ pkgId }) {
    const options = {
      url: '/api/giftPack/newmembergift',
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadRegCouponPkgCompletion(pkgId, result.error, result.data));
  });
}

export function* watchTakeRegCouponPkg() {
  yield takeEvery('TAKE_REG_COUPON_PKG', function*({ pkgId }) {
    const options = {
      url: '/api/giftPack/newmembergift/get',
      method: 'POST',
    };
    const result = yield call(app.httpFetch, options);
    yield put(takeRegCouponPkgCompletion(pkgId, result.error, result.data));
  });
}

export function* watchLoadCouponBatchList() {
  yield takeEvery('LOAD_COUPON_BATCH_LIST', function*({ willReload }) {
    const { list, query } = yield select(
      state => state.mall.coupon.batchMaster
    );
    let start = 0;
    if (!willReload && list) {
      start = list.length;
    }

    const { size, type, oprate, keyword } = query;
    const options = {
      url: '/api/coupons/getOprateMyCoupons',
      data: {
        start,
        size,
        type: type || undefined,
        oprate: oprate || undefined,
        name: keyword || undefined,
      },
    };

    const result = yield call(app.httpFetch, options);
    yield put(
      loadCouponBatchListCompletion(
        result.error,
        (result.data && result.data.listData) || []
      )
    );
  });
}

export function* watchLoadCouponBatchDonateList() {
  yield takeEvery('LOAD_COUPON_BATCH_DONATE_LIST', function*() {
    const { query } = yield select(
      state => state.mall.coupon.batchDonateMaster
    );
    const options = {
      url: '/api/coupons/couponsDetail',
      method: 'POST',
      data: {
        ids: query.couponIds.length > 0 ? query.couponIds : undefined,
      },
    };

    const result = yield call(app.httpFetch, options);
    yield put(
      loadCouponBatchDonateListCompletion(
        result.error,
        (result.data && result.data.listData) || []
      )
    );
  });
}

export default function* couponSaga() {
  yield all([
    fork(watchLoadGiftList),
    fork(watchLoadStoreList),
    fork(watchLoadCashList),
    fork(watchLoadPostageList),
    fork(watchLoadCoupon),
    fork(watchBatchGetCoupon),
    fork(watchBatchCancelDonateCoupon),
    fork(watchBatchDonateCoupon),
    fork(watchLoadPickerGiftList),
    fork(watchLoadReceivedCouponList),
    fork(watchLoadNewuserCouponList),
    fork(watchLoadCouponPkg),
    fork(watchTakeCouponPkg),
    fork(watchLoadRegCouponPkg),
    fork(watchTakeRegCouponPkg),
    fork(watchLoadCouponBatchList),
    fork(watchLoadCouponBatchDonateList),
  ]);
}
